import type {
  AssetResultMatch as AssetResultMatchType,
  TranscriptionResultMatch,
} from '@frameio/graphql-client/generated';

export type ResultSource = 'Standard' | 'MediaIntelligence';

// Types with stubbed or missing GraphQL support
type StubbedMatches = TranscriptMatch;

export type AssetResultMatch =
  | AssetResultMatchType
  | StubbedMatches
  // @hack see FeaturedFieldMatches.tsx for more details
  | TranscriptionResultMatch;

export type AssetResultMatchTypename = AssetResultMatch['__typename'];

export type OnMatchClickHandler = (
  matchTypename: AssetResultMatchTypename
) => void;

/**
 * Section IDs for search results in MULTI mode.
 * - 'lexical': Standard lexical search results (Quick Results section)
 * - 'nlp': NLP/AI-powered search results (AI Results section)
 */
export type SearchMode = 'lexical' | 'nlp';
export type SectionId = SearchMode;

export const LEXICAL_SECTION_ID: SectionId = 'lexical';
export const NLP_SECTION_ID: SectionId = 'nlp';

/**
 * Stubbed matches for asset result types
 * */
export type TranscriptMatch = {
  __typename: 'TranscriptMatch';
  id?: string;
  value: boolean;
  color?: string;
};

export type SearchHistoryItem = {
  mode: SearchMode;
  query: string;
};
export type SearchHistory = SearchHistoryItem[];
